export const HTTP_POST_METHOD = "post";
export const HTTP_GET_METHOD = "get";
export const HTTP_DELETE_METHOD = "delete";
export const NUMBER_OF_RELATED_ARTICLES = 2;
